const init = () => {
    document.addEventListener('DOMContentLoaded', () => {
        const lazyImages = document.querySelectorAll('img[data-src]');

        if ('IntersectionObserver' in window) {
            const observer = new IntersectionObserver((entries, observer) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        const img = entry.target;
                        img.src = img.dataset.src; // Replace placeholder with actual image
                        img.removeAttribute('data-src'); // Clean up

                        // Add load event listener to add the `loaded` class
                        img.addEventListener('load', () => {
                            img.classList.add('loaded');
                        });

                        observer.unobserve(img); // Stop observing the image
                    }
                });
            });

            lazyImages.forEach((img) => observer.observe(img));
        } else {
            // Fallback for older browsers
            lazyImages.forEach((img) => {
                img.src = img.dataset.src; // Replace src directly for unsupported browsers
                img.removeAttribute('data-src');

                // Add load event listener to add the `loaded` class
                img.addEventListener('load', () => {
                    img.classList.add('loaded');
                });
            });
        }
    });
};

export default init;
